export const Insurers = {
  companies: {
    ALLS: {
      fullName: 'Allstate Life Insurance Co of New York',
      shortName: 'Allstate',
      NCIA: 70874,
      rating: 'A+',
      complaintIndex: 0.25,
      convertible: false,
      unsettled: 24,
      notes:
        'This company is part of Allstate but is a separate insurer that issues policies in New York.  Information being shown is specific to the NY insurer except for year founded, location, type of company, and website.',
      ownership: 'Stock',
      stock: 'ALL',
      founded: '1931',
      location: 'Northbrook, IL',
      url: 'http://www.myallstatefinancial.com/life-insurance/',
      lines: ['Life Insurance', 'Property & Casualty', 'Asset Management', '', ''],
      rank: 37,
      share: 0.0013,
      policies: 14295,
      premiums: '91950076',
      claimsPaid: '54803655',
      claimsMade: '55749861',
    },
    AMGE: {
      fullName: 'American General Life Companies (Non NY)',
      shortName: 'Am General',
      NCIA: 60488,
      rating: 'A',
      complaintIndex: 0.18,
      convertible: false,
      unsettled: 27,
      notes: '',
      ownership: 'Stock',
      stock: '',
      founded: '1925',
      location: 'Houston, TX',
      url: 'http://www.americangeneral.com/',
      lines: ['Life insurance', 'Disability', '', '', ''],
      rank: 9,
      share: 0.0275,
      policies: 195201,
      premiums: '1182681256',
      claimsPaid: '2275961164',
      claimsMade: '2260947792',
    },
    AMNT: {
      fullName: 'American National Insurance Company ',
      shortName: 'Am National',
      NCIA: 60739,
      rating: 'A',
      complaintIndex: 0.98,
      convertible: false,
      unsettled: 37,
      notes: '',
      ownership: 'Stock',
      stock: 'ANAT',
      founded: '1905',
      location: 'Galveston, TX',
      url: 'http://www.anico.com/',
      lines: ['Life Insurance', 'Disability', 'Health Insurance', 'Propery & Casualty', 'Asset Management'],
      rank: 26,
      share: 0.0038,
      policies: 100667,
      premiums: '375795154',
      claimsPaid: '201455606',
      claimsMade: '207798309',
    },
    AMTA: {
      fullName: 'Ameritas Life Insurance Corp ',
      shortName: 'Ameritas',
      NCIA: 61301,
      rating: 'A',
      complaintIndex: 0.26,
      convertible: false,
      unsettled: 21,
      notes: '',
      ownership: 'Mutual',
      stock: '',
      founded: '1887',
      location: 'Lincoln, NE',
      url: 'https://www.google.com/url?sa=t&rct=j&q=&esrc=s&source=web&cd=1&ved=0CCwQFjAA&url=http%3A%2F%2Fwww.ameritas.com%2F&ei=UJfUUde7AeXM0gHi2YHYBA&usg=AFQjCNGBNCmRsq5BmXCoBpqVLliXMi9WfA&bvm=bv.48705608,d.dmQ',
      lines: ['Life Insurance', 'Disability', 'Health Insurance', 'Asset management', ''],
      rank: 25,
      share: 0.0019,
      policies: 12909,
      premiums: '1888850283',
      claimsPaid: '64265221',
      claimsMade: '67194448',
    },
    AMTY: {
      fullName: 'Ameritas Life Insurance Corp of New York ',
      shortName: 'Ameritas',
      NCIA: 60033,
      rating: 'A',
      complaintIndex: 0.47,
      convertible: false,
      unsettled: 45,
      notes:
        'This company is part of Ameritas but is a separate insurer that issues policies in New York.  Information being shown is specific to the NY insurer except for year founded, location, type of company, and website.',
      ownership: '',
      stock: '',
      founded: '',
      location: '',
      url: '',
      lines: ['', '', '', '', ''],
      rank: 42,
      share: 3e-4,
      policies: 2813,
      premiums: '35621155',
      claimsPaid: '384099',
      claimsMade: '557325',
    },
    ASSU: {
      fullName: 'Assurity Life Insurance Company',
      shortName: 'Assurity',
      NCIA: 71439,
      rating: 'A-',
      complaintIndex: 0.24,
      convertible: false,
      unsettled: 23,
      notes: '',
      ownership: 'Stock',
      stock: '',
      founded: '1890',
      location: 'Lincoln, NE',
      url: 'http://www.assurity.com/',
      lines: ['Life Insurance', 'Disability', '', '', ''],
      rank: 34,
      share: 0.0013,
      policies: 15253,
      premiums: '142723935',
      claimsPaid: '56368075',
      claimsMade: '58311373',
    },
    AVIV: {
      fullName: 'Aviva Life & Annuity Company',
      shortName: 'Aviva',
      NCIA: 61689,
      rating: 'A-',
      complaintIndex: 0.52,
      convertible: false,
      unsettled: 27,
      notes: "This company's life insurance business is in transition and is in the process of being sold.",
      ownership: 'Stock',
      stock: '',
      founded: '1896',
      location: 'Des Moines, IA',
      url: 'http://www.avivausa.com/',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 12,
      share: 0.0123,
      policies: 25506,
      premiums: '1230580971',
      claimsPaid: '392681782',
      claimsMade: '422213426',
    },
    AVIY: {
      fullName: 'Aviva Life & Annuity Company of NY',
      shortName: 'Aviva',
      NCIA: 63932,
      rating: 'A-',
      complaintIndex: 0.3,
      convertible: false,
      unsettled: 62,
      notes:
        "This company's life insurance business is in transition and is in the process of being sold. This company is part of Aviva but is a separate insurer that issues policies in New York.  Information being shown is specific to the NY insurer except for year founded, location, type of company, and website.",
      ownership: 'Stock',
      stock: '',
      founded: '',
      location: '',
      url: 'http://www.avivausa.com/',
      lines: ['', '', '', '', ''],
      rank: 36,
      share: 0.0016,
      policies: 2160,
      premiums: '47680781',
      claimsPaid: '24200221',
      claimsMade: '23898869',
    },
    AXAA: {
      fullName: 'Axa Equitable',
      shortName: 'Axa',
      NCIA: 62944,
      rating: 'A+',
      complaintIndex: 0.13,
      convertible: false,
      unsettled: 21,
      notes: 'Part of France holding company.',
      ownership: 'Stock',
      stock: '',
      founded: '1859',
      location: 'New York, NY',
      url: 'http://www.axa-equitable.com/',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 7,
      share: 0.0227,
      policies: 36556,
      premiums: '2536943816',
      claimsPaid: '1629724490',
      claimsMade: '1662504148',
    },
    BANN: {
      fullName: 'Banner Life',
      shortName: 'Banner',
      NCIA: 94250,
      rating: 'A+',
      complaintIndex: 0.29,
      convertible: false,
      unsettled: 18,
      notes: 'Banner is Legal & General of America, part of the Legal and General Financial Group.',
      ownership: 'Stock',
      stock: 'LON:LGEN',
      founded: '1949',
      location: 'Frederick, MD',
      url: 'https://www.lgamerica.com',
      lines: ['Life Insurance', '', '', '', ''],
      rank: 28,
      share: 0.0067,
      policies: 107353,
      premiums: '95566979',
      claimsPaid: '452501522',
      claimsMade: '441837841',
      image: 'legal-general-grey.png',
      product: 'OPTerm',
      active: true,
    },
    COMP: {
      fullName: 'Companion of NY',
      shortName: 'Companion',
      NCIA: 62243,
      rating: 'A+',
      complaintIndex: 0.19,
      convertible: false,
      unsettled: 14,
      notes: 'Subsidiary of Mutual of Omaha.',
      ownership: 'Stock',
      stock: '',
      founded: '1971',
      location: 'Columbia, SC',
      url: 'http://www.companionlife.com/',
      lines: ['Life Insurance', '', '', '', ''],
      rank: 39,
      share: 8e-4,
      policies: 11781,
      premiums: '76092254',
      claimsPaid: '51006642',
      claimsMade: '50705050',
    },
    FIDL: {
      fullName: 'Fidelity Life Association',
      shortName: 'Fidelity',
      NCIA: 63290,
      rating: 'A-',
      complaintIndex: 1.42,
      convertible: false,
      unsettled: 32,
      notes: '',
      ownership: 'Stock subsidiary of mutual holding company',
      stock: '',
      founded: '1896',
      location: 'Chicago, IL',
      url: 'http://www.fidelitylife.com/',
      lines: ['Life Insurance', '', '', '', ''],
      rank: 40,
      share: 8e-4,
      policies: 23959,
      premiums: '50717117',
      claimsPaid: '51787504',
      claimsMade: '52034092',
    },
    FIRM: {
      fullName: 'First MetLife Investors Insurance Co ',
      shortName: 'MetLife',
      NCIA: 60992,
      rating: 'A+',
      complaintIndex: 0.2,
      convertible: false,
      unsettled: 19,
      notes:
        'This company is part of MetLife but is a separate insurer that issues policies in New York.  Information being shown is specific to the NY insurer except for year founded, location, type of company, and website.',
      ownership: 'Stock',
      stock: 'MET',
      founded: '1864',
      location: 'New York, NY',
      url: 'https://www.metlife.com/',
      lines: ['Life Insurance', 'Disability', 'Property & Casualty Insurance', 'Asset Management', ''],
      rank: 29,
      share: 8e-4,
      policies: 14173,
      premiums: '47000916',
      claimsPaid: '40900453',
      claimsMade: '44605247',
    },
    GUAR: {
      fullName: 'Guardian Life Insurance Co of America ',
      shortName: 'Guardian',
      NCIA: 64246,
      rating: 'A++',
      complaintIndex: -1,
      convertible: true,
      unsettled: 23,
      notes:
        "With the normal conversion option you can convert anytime in the first 5 years from time of policy issue. With an extended conversion cption you can convert anytime during the policy's term period.",
      ownership: 'Mutual',
      stock: '',
      founded: '1860',
      location: 'New York, NY',
      url: 'http://www.guardianlife.com/',
      lines: ['Life Insurance', 'Disability', 'Health Insurance', 'Propery & Casualty', 'Asset Management'],
      rank: 11,
      share: 0.0263,
      policies: 47268,
      premiums: '3364242598',
      claimsPaid: '573006848',
      claimsMade: '580761828',
      image: 'guardian.png',
    },
    HART: {
      fullName: 'Hartford Life & Annuity Insurance Company',
      shortName: 'Hartford',
      NCIA: 71153,
      rating: 'A',
      complaintIndex: 0.14,
      convertible: false,
      unsettled: 21,
      notes: '',
      ownership: 'Stock',
      stock: 'HIG',
      founded: '1810',
      location: 'Hartford, CT',
      url: 'http://www.thehartford.com/',
      lines: ['Life Insurance', 'Disability', 'Propery & Casualty', '', ''],
      rank: 20,
      share: 0.0145,
      policies: 25506,
      premiums: '1266133013',
      claimsPaid: '500558914',
      claimsMade: '538234869',
    },
    HARY: {
      fullName: 'Hartford Life Insurance Company ',
      shortName: 'Hartford',
      NCIA: 88072,
      rating: 'A',
      complaintIndex: 0.55,
      convertible: false,
      unsettled: 28,
      notes: '',
      ownership: 'Stock',
      stock: 'HIG',
      founded: '1810',
      location: 'Hartford, CT',
      url: 'http://www.thehartford.com/',
      lines: ['Life Insurance', 'Disability', 'Propery & Casualty', '', ''],
      rank: 18,
      share: 0.0021,
      policies: 2261,
      premiums: '175196144',
      claimsPaid: '297383284',
      claimsMade: '308628031',
    },
    INDE: {
      fullName: 'Independent Order of Foresters ',
      shortName: 'Foresters',
      NCIA: 58068,
      rating: 'A',
      complaintIndex: -1,
      convertible: false,
      unsettled: 47,
      notes: '',
      ownership: 'Fraternal',
      stock: '',
      founded: '1874',
      location: 'Ontraio, Canada',
      url: 'http://www.foresters.com/',
      lines: ['Life Insurance', 'Asset Management (via subsidiaries)', '', '', ''],
      rank: 32,
      share: 0,
      policies: 105621,
      premiums: '295974304',
      claimsPaid: '130397712',
      claimsMade: '127853257',
    },
    JOHU: {
      fullName: 'John Hancock Life Insurance Company USA ',
      shortName: 'J Hancock',
      NCIA: 65838,
      rating: 'A+',
      complaintIndex: 0,
      convertible: false,
      unsettled: 19,
      notes: 'Part of Manulife Financial.',
      ownership: 'Stock',
      stock: 'MFC',
      founded: '1862',
      location: 'Boston, MA',
      url: 'http://www.johnhancock.com/',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 27,
      share: 0.0027,
      policies: 28637,
      premiums: '2237391733',
      claimsPaid: '2872569203',
      claimsMade: '2935449365',
    },
    JOHY: {
      fullName: 'John Hancock Life Insurance Company of NY ',
      shortName: 'J Hancock',
      NCIA: 86375,
      rating: 'A+',
      complaintIndex: 0.09,
      convertible: false,
      unsettled: 51,
      notes:
        'Part of Manulife Financial. This company is part of MetLife but is a separate insurer that issues policies in New York.  Information being shown is specific to the NY insurer except for year founded, location, type of company, and website.',
      ownership: 'Stock',
      stock: 'MFC',
      founded: '1862',
      location: 'Boston, MA',
      url: 'http://www.johnhancock.com/',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 2,
      share: 0.0447,
      policies: 2325,
      premiums: '241744038',
      claimsPaid: '38930384',
      claimsMade: '45250813',
    },
    LNBE: {
      fullName: 'Lincoln Benefit Life / Allstate',
      shortName: 'Allstate',
      NCIA: 65595,
      rating: 'A+',
      complaintIndex: 0.18,
      convertible: false,
      unsettled: 17,
      notes:
        'Part of Allstate. Providing information for Allstate. Note that it is rumored that Allstate is looking to sell Lincoln Benefit.',
      ownership: 'Stock',
      stock: 'ALL',
      founded: '1931',
      location: 'Northbrook, IL',
      url: 'http://www.myallstatefinancial.com/life-insurance/',
      lines: ['Life Insurance', 'Property & Casualty', 'Asset Management', '', ''],
      rank: 23,
      share: 0.0124,
      policies: 125033,
      premiums: '',
      claimsPaid: '648687571',
      claimsMade: '667472392',
    },
    LNNA: {
      fullName: 'Lincoln National Life Insurance Company',
      shortName: 'Lincoln',
      NCIA: 65676,
      rating: 'A+',
      complaintIndex: 0.12,
      convertible: false,
      unsettled: 15,
      notes: '',
      ownership: 'Stock',
      stock: 'LNC',
      founded: '1905',
      location: 'Fort Wayne, IN',
      url: 'https://www.lfg.com',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 3,
      share: 0.0425,
      policies: 48024,
      premiums: '2665504991',
      claimsPaid: '2025017326',
      claimsMade: '2057927668',
    },
    MASM: {
      fullName: 'MassMutual (Massachusets Mutual Life Insurance Company)',
      shortName: 'MassMutual',
      NCIA: 65935,
      rating: 'A++',
      complaintIndex: 0.03,
      convertible: true,
      unsettled: 18,
      notes:
        'You can convert anytime in the first 10 years from the time of policy issue.  However, if you are 55 years old or older, you will only be able to convert until the policy anniversary date closest to your 65th birthday',
      ownership: 'Mutual',
      stock: '',
      founded: '1851',
      location: 'Springfield, MA',
      url: 'http://www.massmutual.com/',
      lines: ['Life Insurance', 'Disability', 'Asset Management', '', ''],
      rank: 4,
      share: 0.0326,
      policies: 76335,
      premiums: '4260871468',
      claimsPaid: '1407396278',
      claimsMade: '1421363447',
      image: 'MassMutualNoFinancial.png',
      product: 'Vantage Term',
      active: false,
    },
    CAS: {
      fullName: 'Massachusetts Mutual Life Insurance Company',
      shortName: 'MassMutual',
      NCIA: 0,
      rating: 'A++',
      complaintIndex: 0.03,
      convertible: true,
      unsettled: 18,
      notes: 'Convertible',
      ownership: 'Mutual',
      stock: '',
      founded: '1851',
      location: 'Springfield, MA',
      url: 'http://www.massmutual.com/',
      lines: ['Life Insurance', 'Disability', 'Asset Management', '', ''],
      rank: 4,
      share: 0.0326,
      policies: 76335,
      premiums: '4260871468',
      claimsPaid: '1407396278',
      claimsMade: '1421363447',
      image: 'MassMutualNoFinancial.png',
      product: 'MassMutual Term',
      active: true,
    },
    HAVE: {
      fullName: 'HavenLife (Massachusetts Mutual Life Insurance Company)',
      shortName: 'Haven',
      NCIA: 0,
      rating: 'A++',
      complaintIndex: 0.03,
      convertible: true,
      unsettled: 18,
      notes: 'Not Convertable',
      ownership: 'Mutual',
      stock: '',
      founded: '1851',
      location: 'Springfield, MA',
      url: 'http://www.massmutual.com/',
      lines: ['Life Insurance', 'Disability', 'Asset Management', '', ''],
      rank: 4,
      share: 0.0326,
      policies: 76335,
      premiums: '4260871468',
      claimsPaid: '1407396278',
      claimsMade: '1421363447',
      image: 'HLIF-transparent-inhouse.png',
      product: 'Haven Term',
      active: true,
    },
    METL: {
      fullName: 'Metropolitan Life',
      shortName: 'MetLife',
      NCIA: 65978,
      rating: 'A+',
      complaintIndex: 0.52,
      convertible: false,
      unsettled: 18,
      notes: '',
      ownership: 'Stock',
      stock: 'MET',
      founded: '1864',
      location: 'New York, NY',
      url: 'https://www.metlife.com/',
      lines: ['Life Insurance', 'Disability', 'Property & Casualty Insurance', 'Asset Management', ''],
      rank: 1,
      share: 0.0273,
      policies: 29932,
      premiums: '1814001179',
      claimsPaid: '2434100724',
      claimsMade: '2340485180',
      product: 'Guaranteed Level Term',
      image: 'MetLife-grey.png',
      active: true,
    },
    MINM: {
      fullName: 'Minnesota Life Insurance Company ',
      shortName: 'Minnesota',
      NCIA: 66168,
      rating: 'A+',
      complaintIndex: 0.04,
      convertible: false,
      unsettled: 18,
      notes: 'Part of Securian Financial Group.',
      ownership: 'Stock',
      stock: '',
      founded: '1880',
      location: 'St. Paul, MN',
      url: 'http://www.securian.com/',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 14,
      share: 0.0092,
      policies: 31393,
      premiums: '983077337',
      claimsPaid: '258152532',
      claimsMade: '266463143',
    },
    NATW: {
      fullName: 'Nationwide Life and Annuity Insurance Co ',
      shortName: 'Nationwide',
      NCIA: 66869,
      rating: 'A+',
      complaintIndex: 0.31,
      convertible: false,
      unsettled: 12,
      notes: '',
      ownership: 'Mutual',
      stock: '',
      founded: '1925',
      location: 'Columbus, OH',
      url: 'http://www.nationwide.com',
      lines: ['Life Insurance', 'Property & Casualty', 'Asset Management', 'Banking', ''],
      rank: 8,
      share: 0.0068,
      policies: 4603,
      premiums: '668450052',
      claimsPaid: '445740974',
      claimsMade: '446287505',
      image: 'NATW.gif',
    },
    NORA: {
      fullName: 'North American Company for Life and Health Insurance',
      shortName: 'N American',
      NCIA: 66974,
      rating: 'A+',
      complaintIndex: 0.65,
      convertible: false,
      unsettled: 22,
      notes: 'Part of Sammnos Financial Group.',
      ownership: 'Stock',
      stock: 'SFG',
      founded: '1886',
      location: 'Chicago, IL',
      url: 'https://www.northamericancompany.com',
      lines: ['Life Insurance', '', '', '', ''],
      rank: 22,
      share: 0.0049,
      policies: 23800,
      premiums: '283495035',
      claimsPaid: '291142500',
      claimsMade: '296247772',
    },
    NORM: {
      fullName: 'Northwestern Mutual',
      shortName: 'Northwestern',
      NCIA: 0,
      rating: 'A++',
      complaintIndex: 0,
      convertible: true,
      unsettled: 0,
      notes: '',
      ownership: 'Mutual',
      stock: '',
      founded: '1872',
      location: 'Milwaukee, WI',
      url: 'https://www.northwesternmutual.com/',
      lines: ['Life Insurance', '', '', '', ''],
      rank: 0,
      share: 0,
      policies: 0,
      premiums: '0',
      claimsPaid: '0',
      claimsMade: '0',
      image: 'northwestern-grey.png',
      product: 'Term',
      active: true,
    },
    PRIN: {
      fullName: 'Principal Life Insurance Company',
      shortName: 'Principal',
      NCIA: 61271,
      rating: 'A+',
      complaintIndex: 0.07,
      convertible: false,
      unsettled: 16,
      notes: '',
      ownership: 'Stock',
      stock: 'PFG',
      founded: '1879',
      location: 'Des Moines, IA',
      url: 'http://www.principal.com/',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 13,
      share: 0.009,
      policies: 4291,
      premiums: '1324471369',
      claimsPaid: '453874593',
      claimsMade: '460990347',
      image: 'PRIP.png',
    },
    PRIP: {
      fullName: 'Principal National Life Insurance Company',
      shortName: 'Principal',
      NCIA: 71161,
      rating: 'A+',
      complaintIndex: 0,
      convertible: false,
      unsettled: 101,
      notes:
        'Part of Principal Financial group. Information shows is specific to Principal National Life Insurance Company except for location, year founded, company type, and website.',
      ownership: 'Stock',
      stock: '',
      founded: '',
      location: '',
      url: '',
      lines: ['', '', '', '', ''],
      rank: 30,
      share: 0.0051,
      policies: 25825,
      premiums: '6553',
      claimsPaid: '8958632',
      claimsMade: '17034883',
    },
    PROT: {
      fullName: 'Protective Life Insurance Company',
      shortName: 'Protective',
      NCIA: 68136,
      rating: 'A+',
      complaintIndex: 0.26,
      convertible: false,
      unsettled: 15,
      notes: '',
      ownership: 'Stock',
      stock: 'PL',
      founded: '1907',
      location: 'Birmingham, AL',
      url: 'http://www.protective.com/',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 16,
      share: 0.0155,
      policies: 46591,
      premiums: '816333453',
      claimsPaid: '1107132258',
      claimsMade: '1135628482',
    },
    PRUJ: {
      fullName: 'Pruco Life Insurance Co / Prudential',
      shortName: 'Prudential',
      NCIA: 79227,
      rating: 'A+',
      complaintIndex: 0.04,
      convertible: false,
      unsettled: 23,
      notes:
        'This company is part of Prudential but is a separate insurer that issues policies.  Information being shown is specific to this insurer except for year founded, location, type of company, and website.',
      ownership: 'Stock',
      stock: 'PRU',
      founded: '1875',
      location: 'Newark, NJ',
      url: 'http://www.prudential.com/',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 5,
      share: 0.0227,
      policies: 99695,
      premiums: '1125993623',
      claimsPaid: '880736064',
      claimsMade: '922578961',
      image: 'prudential-grey.png',
      product: 'Term Elite',
    },
    PRUC: {
      fullName: 'Pruco Life Insurance Co of NJ',
      shortName: 'Prudential',
      NCIA: 97195,
      rating: 'A+',
      complaintIndex: 0,
      convertible: false,
      unsettled: 23,
      notes:
        'This company is part of Prudential but is a separate insurer that issues policies in NY and NJ.  Information being shown is specific to this insurer except for year founded, location, type of company, and website.',
      ownership: '',
      stock: '',
      founded: '',
      location: '',
      url: 'http://www.prudential.com/',
      lines: ['', '', '', '', ''],
      rank: 21,
      share: 0.0034,
      policies: 13166,
      premiums: '103342609',
      claimsPaid: '145564705',
      claimsMade: '144025435',
      image: 'prudential-grey.png',
      product: 'Term Elite',
    },
    RELL: {
      fullName: 'ING / Reliastar Life Insurance Company',
      shortName: 'ING',
      NCIA: 67105,
      rating: 'A',
      complaintIndex: 0.28,
      convertible: false,
      unsettled: 29,
      notes:
        'Will be changing its name to Voya Financial in 2014. Voya Financial (formerly ING U.S.) is still part of Dutch financial services provider ING Group. ',
      ownership: 'Stock',
      stock: 'VOYA',
      founded: '1975',
      location: 'Minneapolis, MN',
      url: 'http://ing.us/',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 19,
      share: 0.0104,
      policies: 133853,
      premiums: '99507834',
      claimsPaid: '738911434',
      claimsMade: '735404054',
    },
    RELR: {
      fullName: 'ING / Reliastar Life Insurance Company of NY',
      shortName: 'ING',
      NCIA: 61360,
      rating: 'A',
      complaintIndex: 0.42,
      convertible: false,
      unsettled: 23,
      notes:
        'Will be changing its name to Voya Financial in 2014. Voya Financial (formerly ING U.S.) is still part of Dutch financial services provider ING Group. This company is part of ING but is a separate insurer that issues policies in New York.  Information being shown is specific to the NY insurer except for year founded, location, type of company, and website.',
      ownership: '',
      stock: '',
      founded: '',
      location: '',
      url: '',
      lines: ['', '', '', '', ''],
      rank: 33,
      share: 0.0023,
      policies: 11578,
      premiums: '105252529',
      claimsPaid: '171178534',
      claimsMade: '158338575',
    },
    SAGI: {
      fullName: 'Sagicor Life Insurance Company ',
      shortName: 'Sagicor',
      NCIA: 60445,
      rating: 'A-',
      complaintIndex: 0.83,
      convertible: false,
      unsettled: 40,
      notes: '',
      ownership: 'Stock',
      stock: 'LON: SFI',
      founded: '1840',
      location: 'Saint Michael, Barbados',
      url: 'http://www.sagicor.com/',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 38,
      share: 4e-4,
      policies: 1254,
      premiums: '38537767',
      claimsPaid: '11398683',
      claimsMade: '14516151',
    },
    SAVE: {
      fullName: 'SBLI (Savings Bank Life Insurance Co of MA)',
      shortName: 'SBLI',
      NCIA: 70435,
      rating: 'A+',
      complaintIndex: 0.19,
      convertible: false,
      unsettled: 17,
      notes: '',
      ownership: 'Stock',
      stock: '',
      founded: '1907',
      location: 'Woburn, MA',
      url: 'http://www.centrian.com/',
      lines: ['Life Insurance', '', '', '', ''],
      rank: 31,
      share: 0.0025,
      policies: 28768,
      premiums: '1170973502',
      claimsPaid: '132924352',
      claimsMade: '133053729',
      image: 'SAVE.png',
    },
    SECU: {
      fullName: 'Securian Life Insurance Company ',
      shortName: 'Securian',
      NCIA: 93742,
      rating: 'A+',
      complaintIndex: 0,
      convertible: false,
      unsettled: 199,
      notes: 'Securian includes Minnesota Life Insurance Company.',
      ownership: 'Stock',
      stock: '',
      founded: '1880',
      location: 'St. Paul, MN',
      url: 'http://www.securian.com/',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 41,
      share: 1e-4,
      policies: 258,
      premiums: '15770656',
      claimsPaid: '25000',
      claimsMade: '12267',
    },
    TRAF: {
      fullName: 'Transamerica Financial Life Insurance Company',
      shortName: 'Transamerica',
      NCIA: 70688,
      rating: 'A+',
      complaintIndex: 0.29,
      convertible: false,
      unsettled: 31,
      notes: 'Part of Dutch financial holding company Aegeon A.V.',
      ownership: 'Stock',
      stock: 'AEG',
      founded: '1930',
      location: 'Cedar Rapids, IA',
      url: 'http://www.transamerica.com/',
      lines: ['Life Insurance', '', '', '', ''],
      rank: 15,
      share: 0.0011,
      policies: 10416,
      premiums: '104068708',
      claimsPaid: '41962589',
      claimsMade: '37995985',
      image: 'TRAF-grey.png',
    },
    TRAN: {
      fullName: 'Transamerica Life Insurance Company',
      shortName: 'Transamerica',
      NCIA: 86231,
      rating: 'A+',
      complaintIndex: 0.21,
      convertible: false,
      unsettled: 18,
      notes: 'Part of Dutch financial holding company Aegeon A.V.  ',
      ownership: 'Stock',
      stock: 'AEG',
      founded: '1930',
      location: 'Cedar Rapids, IA',
      url: 'http://www.transamerica.com/',
      lines: ['Life Insurance', '', '', '', ''],
      rank: 6,
      share: 0.0208,
      policies: 117691,
      premiums: '1017954963',
      claimsPaid: '2150998543',
      claimsMade: '2196911886',
      product: 'Trendsetter Super',
      image: 'TRAF-grey.png',
      active: true,
    },
    UTHO: {
      fullName: 'United Home Life Insurance Company',
      shortName: 'United Home',
      NCIA: 69922,
      rating: 'A-',
      complaintIndex: 1.93,
      convertible: false,
      unsettled: 35,
      notes: '',
      ownership: 'Stock',
      stock: '',
      founded: '1937',
      location: 'Indianapolics, IN',
      url: 'http://www.unitedhomelife.com/',
      lines: ['Life Insurance', '', '', '', ''],
      rank: 43,
      share: 3e-4,
      policies: 11673,
      premiums: '16720876',
      claimsPaid: '9795913',
      claimsMade: '10682381',
    },
    UTOM: {
      fullName: 'United of Omaha Life Insurance Company ',
      shortName: 'United Omaha',
      NCIA: 69868,
      rating: 'A+',
      complaintIndex: 0.69,
      convertible: false,
      unsettled: 19,
      notes:
        'Subsidiary of Mutual of Omaha. Information provided is specific to United of Omaha except for year founded, location, wesbite, and type of company, which is for Mutual of Omaha.',
      ownership: 'Stock',
      stock: '',
      founded: '1909',
      location: 'Omaha, NE',
      url: 'http://www.mutualofomaha.com/life-insurance/',
      lines: [
        'Life Insurance',
        'Disability (through other subsidiaries)',
        'Asset Management (through other subsidiaries)',
        '',
        '',
      ],
      rank: 17,
      share: 0.0103,
      policies: 267350,
      premiums: '985808347',
      claimsPaid: '614274646',
      claimsMade: '615622572',
    },
    UTST: {
      fullName: 'United States Life Insurance in the City of NY',
      shortName: 'US Life',
      NCIA: 70106,
      rating: 'A',
      complaintIndex: 0.25,
      convertible: false,
      unsettled: 27,
      notes:
        'Part of American General Life Companies. Information being shows is specific to US Life Insurance in the City of NY except for year founded, location, website, and type of company.',
      ownership: 'Stock',
      stock: '',
      founded: '1925',
      location: 'Houston, TX',
      url: 'http://www.americangeneral.com/',
      lines: ['Life insurance', 'Disability', '', '', ''],
      rank: 24,
      share: 0.0026,
      policies: 4851,
      premiums: '116764535',
      claimsPaid: '285367795',
      claimsMade: '276693890',
    },
    WILP: {
      fullName: 'William Penn Life Insurance Co of NY ',
      shortName: 'W Penn',
      NCIA: 66230,
      rating: 'A+',
      complaintIndex: 0.19,
      convertible: false,
      unsettled: 21,
      notes:
        'Information provided is for William Penn life insurance, which is part of the Legal and General Financial Group.',
      ownership: 'Stock',
      stock: 'LON:LGEN',
      founded: '1963',
      location: 'Garden City, NY',
      url: 'http://www.lgamerica.com/',
      lines: ['Life Insurance', '', '', '', ''],
      rank: 35,
      share: 0.0017,
      policies: 13126,
      premiums: '1492008',
      claimsPaid: '143881907',
      claimsMade: '139781613',
    },
    PACL: {
      fullName: 'Pacific Life Insurance Company',
      shortName: 'Pacific Life',
      NCIA: 67466,
      rating: 'A+',
      complaintIndex: 0.02,
      convertible: false,
      unsettled: 25,
      notes: '',
      ownership: 'Mutual',
      stock: '',
      founded: '1868',
      location: 'Newport Beach, CA',
      url: 'http://www.pacificlife.com/',
      lines: ['Life Insurance', 'Asset Management', '', '', ''],
      rank: 10,
      share: 0.0246,
      policies: 18281,
      premiums: '2049807839',
      claimsPaid: '965153397',
      claimsMade: '1101349156',
    },
  },
  ratingsLevel: {
    'A++': 15,
    'A+': 14,
    'A': 13,
    'A-': 12,
    'B++': 11,
    'B+': 10,
  },
  numberOfCompanies: 0,
  getNumberOfCompanies(): void {
    this.numberOfCompanies = this.numberOfCompanies || Object.keys(this.companies).length;
    return this.numberOfCompanies;
  },
};
